import React, { useState } from 'react'


const formatDate = (isoString) => {
    if (!isoString) return "-";

    const date = new Date(isoString);

    // Format date manually as DD/MM/YYYY
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;

    // Format time using toLocaleTimeString
    const formattedTime = date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
        timeZone: "Asia/Kolkata",
    });

    return `${formattedDate}, ${formattedTime}`;
};

function GetLeadDetails({ leadDetails }) {

    const [sourceType] = useState(
        {
            1: 'Landing Page', 2: 'Fresh Work', 3: 'FTBV', 4: 'Inquiry',
            5: 'Whatsapp', 6: 'New Fresh Marketer', 7: 'BotBuz', 8: 'Excel', 9: 'Vidyut Freshmarketer', 10: 'RENAV-FORM-INQUIRY',
            11: 'TVS-LP', 12: 'RENAV-WHATSAPP', 13: 'HP-LP', 14: 'VIDA-LP', 15: 'CL', 16: 'TP', 17: 'DS', 18: 'RENAV-MISSED-CALL',
            19: 'RENAV-WHATSAPP-547', 20: 'RENAV-WHATSAPP-348', 21: 'RENAV-WHATSAPP-563', 22: 'RENAV-WHATSAPP-507',
            23: 'RENAV-WHATSAPP-742', 24: 'DIRECT-EXCEL', 25: "DIALSHREE-INBOUND-LEADS", 26: "OLA-EXCEL-IMPORT", 27: "GOOGLE-ADS", 28: "AMPERE-EXCEL-IMPORT", 29: "RETARGETTING"
        }
    )

    const renderHistoryTable = (key, value) => (
        <div key={key} className="mb-4 mt-0">
            <h3 className="font-bold text-lg mb-2">
                {key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())}
            </h3>
            {value.length > 0 ? (
                <table className="w-full border border-collapse border-gray-600 text-sm">
                    <thead className="bg-success text-white">
                        <tr>
                            <th className="p-2 border-l border-gray-400">No.</th>
                            <th className="p-2 border-l border-gray-100">Timestamp</th>
                            <th className="p-2 border-l border-gray-100">Message</th>
                            <th className="p-2 border-l border-gray-100">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {value
                            .slice()
                            .reverse()
                            .map((item, i) => {
                                const rawMsg = item?.message;
                                const msgText = typeof rawMsg === "object" && rawMsg !== null
                                    ? (rawMsg.message || rawMsg.error || JSON.stringify(rawMsg))
                                    : (rawMsg || "-");

                                const isSuccess =
                                    item?.status === "Success" ||
                                    item?.status === "success" ||
                                    item?.status === "Accepted" ||
                                    item?.status === 200 ||
                                    item?.status === 1;

                                const isDanger =
                                    item?.status === "UnSuccess" ||
                                    item?.status === "failure" ||
                                    item?.status === "Rejected" ||
                                    item?.status === "Error" ||
                                    item?.status === 2;

                                const isDuplicate = item?.status === "Duplicate";
                                const isWarning = item?.status === 500;

                                return (
                                    <tr key={i} className="border border-gray-600">
                                        <td className="p-2 border border-gray-600">{i + 1}</td>
                                        <td className="p-2 border border-gray-600">
                                            {item?.timestamp ? formatDate(item.timestamp) : "-"}
                                        </td>
                                        <td className="p-2 border border-gray-600 break-words">
                                            <div>{msgText}</div>
                                            {(item?.orderId || item?.userId) && (
                                                <div className="text-xs text-gray-500 mt-1 flex flex-wrap gap-2">
                                                    {item?.orderId && <span>Order ID: <strong className="text-gray-700">{item.orderId}</strong></span>}
                                                    {item?.userId && <span>User ID: <strong className="text-gray-700">{item.userId}</strong></span>}
                                                </div>
                                            )}
                                        </td>
                                        <td className="p-2 border border-gray-600">
                                            <span
                                                className={`py-1 px-3 rounded text-white ${
                                                    isSuccess
                                                        ? "bg-green-500"
                                                        : isDanger
                                                        ? "bg-red-500"
                                                        : isDuplicate
                                                        ? "bg-blue-500"
                                                        : isWarning
                                                        ? "bg-yellow-500"
                                                        : "bg-gray-500 text-white"
                                                }`}
                                            >
                                                {typeof item?.status === "object" ? JSON.stringify(item.status) : (item?.status || "-")}
                                            </span>
                                        </td>
                                    </tr>
                                );
                            })}
                    </tbody>
                </table>
            ) : (
                <p className="text-gray-500">No History Found</p>
            )}
        </div>
    );

    const renderDialShreeHistoryTable = (key, value) => (
        <div key={key} className="mb-4 mt-0">
            <h3 className="font-bold text-lg mb-2">
                {key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())}
            </h3>
            {Object.keys(value).length !== 0 ? (
                <table className="w-full border border-collapse border-gray-600 text-sm">
                    <thead className="bg-success text-white">
                        <tr>
                            {/* <th className="p-2 border-l border-gray-400">No.</th> */}
                            <th className="p-2 border-l border-gray-100">Timestamp</th>
                            <th className="p-2 border-l border-gray-100">Message</th>
                            <th className="p-2 border-l border-gray-100">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            value?.data?.length > 0 ? (
                                value?.data?.reverse().map((item, i) => (
                                    <tr key={i} className="border border-gray-600">
                                        <td className="p-2 border border-gray-600">{i + 1}</td>
                                        <td className="p-2 border border-gray-600">
                                            {item?.timestamp ? formatDate(item.timestamp) : "-"}
                                        </td>
                                        <td className="p-2 border border-gray-600">
                                            {item?.message || "-"}
                                        </td>
                                        <td className="p-2 border border-gray-600">
                                            <span
                                                className={`py-1 px-3 rounded text-white ${item?.status === "Success"
                                                    ? "bg-green-500" : item?.status === true
                                                        ? "bg-green-500"
                                                        : item?.status === "UnSuccess"
                                                            ? "bg-red-500"
                                                            : item?.status === "Duplicate"
                                                                ? "bg-blue-500"
                                                                : item?.status === "success"
                                                                    ? "bg-green-500"
                                                                    : item?.status === "failure"
                                                                        ? "bg-red-500"
                                                                        : item?.status === 500
                                                                            ? "bg-yellow-500" : item?.status === 200
                                                                                ? "bg-green-500"
                                                                                : item?.status === "Error"
                                                                                    ? "bg-red-500"
                                                                                    : "bg-gray-500 text-white"
                                                    }`}
                                            >
                                                {(item?.status === true ? "Success" : 'Failed') || (item?.status || "-")}
                                            </span>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <>
                                    <tr className="border border-gray-600">
                                        <td className="p-2 border border-gray-600">
                                            {value?.timestamp ? formatDate(value?.timestamp) : "N/A"}
                                        </td>
                                        <td className="p-2 border border-gray-600">
                                            {(value?.message && Array.isArray(value?.error)) ? value?.message : value?.error || "N/A"}
                                        </td>
                                        <td className="p-2 border border-gray-600">
                                            <span
                                                className={`py-1 px-3 rounded text-white ${value?.status === "Success"
                                                    ? "bg-green-500"
                                                    : value?.status === "UnSuccess"
                                                        ? "bg-red-500"
                                                        : value?.status === "Duplicate"
                                                            ? "bg-blue-500"
                                                            : value?.status === "success"
                                                                ? "bg-green-500"
                                                                : value?.status === "failure"
                                                                    ? "bg-red-500"
                                                                    : value?.status === 500
                                                                        ? "bg-yellow-500" : value?.status === 200
                                                                            ? "bg-green-500"
                                                                            : value?.status === "Error"
                                                                                ? "bg-red-500"
                                                                                : "bg-gray-500 text-white"
                                                    }`}
                                            >
                                                {value?.status || "N/A"}
                                            </span>
                                        </td>
                                    </tr>
                                </>
                            )

                        }
                    </tbody>
                </table>
            ) : (
                <p className="text-gray-500">No History Found</p>
            )}
        </div>
    );

    const renderObjectDetails = (key, objectData) => (
        <div key={key} className="mb-4 mt-0">
            <h3 className="font-bold text-lg mb-2">
                {key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())}
            </h3>
            <table className="w-full overflow-scroll border border-collapse border-gray-300 text-sm">
                <thead className="bg-gray-100">
                    <tr>
                        {Object.keys(objectData).map((objKey) => (
                            <th key={objKey} className="border px-3 py-2 text-left capitalize">
                                {objKey.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        {Object.values(objectData).map((objValue, index) => (
                            <td key={index} className="border px-3 py-2 text-gray-700">
                                {objValue || "N/A"}
                            </td>
                        ))}
                    </tr>
                </tbody>
            </table>
        </div>
    );

    return (
        <>

            <div className='grid grid-cols-4 gap-4'>
                {leadDetails && (
                    Object.entries(leadDetails).map(([key, value]) => {
                        if (key === '_id' || key === '__v' || key.endsWith('_history') || key.endsWith('Object') || key.endsWith('object') || key === "flag") return null;
                        // Format key: replace underscores with space and capitalize each word
                        const formattedKey = key
                            .replace(/_/g, ' ')
                            .replace(/\b\w/g, (char) => char.toUpperCase());

                        let displayValue;

                        switch (key) {
                            case "createdAt":
                            case "updatedAt":
                                displayValue = formatDate(value);
                                break;

                            case "source":
                                displayValue = (
                                    <div className="inline-block text-center ">
                                        {sourceType?.[value] || value}
                                    </div>
                                );
                                break;

                            case "pushed_to_revolt":
                                displayValue = (
                                    <div className="inline-block text-center ">
                                        {value === 1 ? "Accepted" : value === 2 ? "Rejected" : "N/A"}
                                    </div>
                                );
                                break;

                            case "pushed_to_tvs":
                                return (
                                    <div className="inline-block text-center">
                                        {value === 1 ? "Completed" : value === 2 ? "Pending" : "N/A"}
                                    </div>
                                );

                            case "tvs_verification":
                                return (
                                    <div className="inline-block text-center">
                                        {value === 1 ? "Accepted" : value === 2 ? "Rejected" : value === 3 ? "Un Processed" : value === 4 ? "Duplicate" : value === 5 ? "Dealer Not Found" : value === 6 ? "Old Leads" : "N/A"}
                                    </div>
                                );

                            case "type":
                                displayValue =
                                    ["Test Ride", "On Road Price", "Offers", "Home Test Ride", "Loan"][
                                    value - 1
                                    ] || "N/A";
                                break;

                            case "revolt_Lead_Process":
                                displayValue = (
                                    <div
                                        className="inline-block text-center ">
                                        {value === 0 ? "Pending" : value === 1 ? "Completed" : value === 2 ? "Duplicate" : value === 3 ? "Failed" : "NA"}
                                    </div>
                                );
                                break;

                            case "simple_verification":
                            case "simple_status":
                                displayValue = (
                                    <div className="inline-block text-center">
                                        {value === 1 ? "Accepted" : value === 2 ? "Rejected" : value === 3 ? "Pending" : "N/A"}
                                    </div>
                                );
                                break;

                            case "pushed_to_simple":
                                displayValue = (
                                    <div className="inline-block text-center">
                                        {value === 1 ? "Success" : value === 2 ? "Pending" : value === 3 ? "Failed" : "N/A"}
                                    </div>
                                );
                                break;

                            default:
                                displayValue = value === null || value === undefined || value === "" ? "N/A" : value.length === 0 ? "N/A" : (typeof value === "object" ? JSON.stringify(value) : value?.toString?.());
                                break;
                        }
                        return (
                            <p className='border p-2 px-4 border-gray-200 break-words' key={key}>
                                <span className="font-bold">{formattedKey}</span>:{" "}
                                <span className="text-gray-700">
                                    {displayValue}
                                </span>
                            </p>
                        );
                    })
                )}
            </div>
            <div className="mt-5 border p-2 px-4 border-gray-200 rounded-md bg-[#e5f3fb] space-y-6 max-w-full overflow-x-auto default-scrollbar">
                {leadDetails && Object.entries(leadDetails).map(([key, value]) => {
                    if (key.endsWith("_history")) {
                        return <div key={key}>{renderHistoryTable(key, value)}</div>;
                    } else if (key.endsWith("Object") && typeof value === "object" && value !== null) {
                        return <div className='w-full' key={key}>{renderObjectDetails(key, value)}</div>;
                    } else if (key === 'dialshreeResponse') {
                        return <div key={key}>{renderDialShreeHistoryTable(key, value)}</div>;
                    }
                    return null;
                })}
            </div>


        </>
    )
}

export default GetLeadDetails